import { IYearMonth } from '@/coreDomainsModule/date';
import { IParentBusiness, IParentBusinessWithMoveWarehouse } from '../entities/Business';
import { BusinessFactory } from '@/coreDomainsModule/factories/BusinessFactory';
import { MoveWarehouseService } from '../services/moveWarehouseService';

/**
 * 親取引のファクトリークラス
 */
export class ParentBusinessWithMoveWarehouseFactory {
  /**
   * IParentBusinessを生成する
   * @param initialData - 初期値
   * @param differenceOccurrenceMonthYear - 差異数量を計算する対象の年月
   */
  public static createFromIParentBusiness = (
    initialData: IParentBusiness,
    differenceOccurrenceMonthYear: IYearMonth
  ): IParentBusinessWithMoveWarehouse => {
    return {
      ...initialData,
      differenceOccurrenceMonthYear,
      differenceAmount: MoveWarehouseService.calcDifferenceAmount(initialData, differenceOccurrenceMonthYear),
    };
  };
}
